// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.
import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug= true

// esbuild-rails enables this
import controllers from "./**/*_controller.js"
controllers.forEach((controller) => {
    console.log("register controller", controller.name, controller.filename);
    application.register(controller.name, controller.module.default)
})

